import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "./Reveal";

const FAQ = [
  ["Come funziona il pagamento online?", "Aggiungi i prodotti al carrello e scegli \u201cPaga con carta\u201d: vieni portato alla pagina di pagamento sicura di Stripe. Ricevi la conferma subito dopo."],
  ["Posso chiedere un preventivo invece di pagare subito?", "Certo. Dal carrello scegli \u201cRichiedi un preventivo\u201d oppure compila il modulo: ti ricontattiamo con una proposta su misura."],
  ["Come valutate il mio usato?", "Indicaci modello, memoria e condizioni nel modulo. Ti diamo una stima e la confermiamo quando vediamo il dispositivo."],
  ["Che garanzia hanno i prodotti?", "Tutti i prodotti nuovi hanno 24 mesi di garanzia legale. Per qualsiasi problema scrivici dal modulo di richiesta."],
];

export const Faq = () => (
  <section className="mx-auto grid max-w-7xl gap-12 px-5 py-28 sm:px-8 lg:grid-cols-12">
    <Reveal className="lg:col-span-4">
      <SectionLabel index="04">FAQ</SectionLabel>
      <h2 className="mt-5 font-display text-4xl font-semibold tracking-tight sm:text-5xl">Domande frequenti</h2>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-8">
      <Accordion type="single" collapsible className="border-t border-fg/10">
        {FAQ.map(([q, a], i) => (
          <AccordionItem key={q} value={`f${i}`} className="border-fg/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl hover:no-underline sm:text-2xl">{q}</AccordionTrigger>
            <AccordionContent className="pb-6 text-base text-fg2">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
